import React from 'react'
import { useHistory } from 'react-router-dom'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { TopNavCTA } from 'components/layout'

export const FleetActions = () => {
  const { trackEvent } = useFMSAnalytics()
  const history = useHistory()

  const addLoadHandler = () => {
    trackEvent('Fleet', 'OPEN_ADD_LOAD_MODAL_FV')
    history.push(`${history.location.pathname}/create-load`)
  }

  return <TopNavCTA dataTest='add-load' label='Add Load' onClick={addLoadHandler} />
}
